import { render, staticRenderFns } from "./AsideMenuComponent.vue?vue&type=template&id=41602ec2&scoped=true"
import script from "./AsideMenuComponent.vue?vue&type=script&lang=js"
export * from "./AsideMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./AsideMenuComponent.vue?vue&type=style&index=0&id=41602ec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41602ec2",
  null
  
)

export default component.exports